import { mapState } from 'vuex';
const nodeUrl = require('url');
export default {
  props: {
    program: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      initConfig: state => state.initConfig,
      serverFunctionList: state => state.serverFunctionList
    })
  },
  data() {
    return {
      previewUrl: '',
      nocGridReTry: 0
    };
  },
  created() {
    const URL = nodeUrl.parse(location.href, true);
    const program = URL.query.program;
    const programId = URL.query.programId;
    switch (program) {
      case 'MediaHub':
        // this.previewUrl = `${this.initConfig.urlInfo.mediahub}/#/operateCenter`
        this.previewUrl = `${this.initConfig.urlInfo.mediahub}/mediahub/#/operateCenter?from=noc`;
        break;
      case 'Production':
        this.previewUrl = `${this.initConfig.urlInfo.producer}/producer/noc/${programId}`;
        break;
      case 'Master Control':
        this.previewUrl = `${this.initConfig.urlInfo.channelApiUrl}/#/nm?programId=${programId}`;
        break;
      case 'NocGrid':
        this.previewUrl = `${location.origin}/noc-grid/#/gridMap`;
        // this.loadGridMap()

        break;
    }
  },
  methods: {
    loadGridMap() {
      if (!this.serverFunctionList) {
        setTimeout(() => {
          if (this.nocGridReTry > 3) {
            this.previewUrl = `${location.origin}/noc-grid/#/gridMap?mapType=GoogleMap`;
            return;
          }
          this.nocGridReTry++;
          this.loadGridMap();
        }, 1000);
      } else {
        const currentServiceList = this.serverFunctionList && this.serverFunctionList.filter(item => item.serviceName == this.initConfig.serverName);
        let IsGoogleMap = false;
        if (currentServiceList) {
          currentServiceList.forEach(item => {
            if (item.permissionList && item.permissionList.length) {
              item.permissionList.forEach(item1 => {
                if (item1.functionName == 'IsGoogleMap' && item1.functionPermission) IsGoogleMap = true;
              });
            }
          });
        }
        this.previewUrl = `${location.origin}/noc-grid/#/gridMap?mapType=${IsGoogleMap ? 'GoogleMap' : 'BaiduMap'}`;
      }
    }
  }
};